import React from "react"

import {addClass, removeClass, clearFormError, getJSON} from '../components/GlobalFunctions';

import SingleInput from '../components/SingleInput';

class Step1 extends React.Component {

	constructor(props) {
		super(props);
		this.onInputFocus = this.onInputFocus.bind(this);
		this.handleCodeChange = this.handleCodeChange.bind(this);
		this.checkForm = this.checkForm.bind(this);
		this.state = {
			email: '',
			hash: '',

			recoveryError: this.props.error?'<p>'+this.props.error+'</p>':'',
			recoveryDisabled: false,
		};
	}

	handleCodeChange(e) {
		if(/^[a-zA-Z0-9]*$/.test(e.target.value)) {
			this.setState({ hash: e.target.value });
		} else {
			this.setState({ recoveryError: '<p>Invalid characters</p>' });
		}
	}

	onInputFocus(s){ addClass(s.target.parentNode,"input--filled"),this.setState({ recoveryError: '' }) }

	onInputBlur(s){ ""===s.target.value.trim()&&removeClass(s.target.parentNode,"input--filled") }
	
	checkForm(e) {
		e.preventDefault();

		var self = this;

		self.setState({ recoveryDisabled: true, recoveryError: '' });
		if(self.state.hash !== '') {
			self.props.setData(self);
			self.props.nextStep.call(this);
		} else {
			self.setState({ recoveryDisabled: false, recoveryError: '<p>Enter your verification code from email!</p>' });
		}
	}

	componentDidMount() {
		for(var fieldList=document.querySelectorAll(".input__field"),i=0;i<fieldList.length;i++)""!==fieldList[i].value.trim()&&addClass(fieldList[i].parentNode,"input--filled");
	}

	render() {
		return (
			<form id="forgotForm" className="form" onSubmit={this.checkForm}>
				<div className="form-info">{this.props.message}</div>
				<div id="forgotError" className="form-error" dangerouslySetInnerHTML={{ __html: this.state.recoveryError }}></div>

				<SingleInput
					inputType={'text'}
					title={'Your verification code from email'}
					name={'forgotEmailCode'}
					content={this.state.emailcode}
					controlFunc={this.handleCodeChange}
					placeholder={'Enter your verification code'}
					focusFunc={this.onInputFocus}
					blurFunc={this.onInputBlur}
					svg={'M14.9,12.7c-0.2,0-0.7-0.6-0.9-0.8l-0.6,0.6l1.5,1.5c0.1,0.1,0.2,0.3,0.2,0.5c0,0.4-0.4,0.8-0.8,0.8 c-0.2,0-0.3-0.1-0.5-0.2l-4.5-4.5c-0.7,0.5-1.6,0.9-2.4,0.9c-1.5,0-2.5-1-2.5-2.5c0-2.2,2.2-4.4,4.4-4.4c1.5,0,2.5,1,2.5,2.5 c0,0.9-0.4,1.7-0.9,2.4l2.4,2.4l0.6-0.6c-0.1-0.1-0.8-0.7-0.8-0.9c0-0.2,0.6-0.8,0.8-0.8c0.1,0,0.1,0,0.2,0.1 c0.2,0.2,2.1,2,2.1,2.2C15.6,12.1,15,12.7,14.9,12.7z M8.7,6C7.9,6,7.4,6.5,7.4,7.2c0,0.2,0,0.4,0.1,0.6C7.3,7.7,7.1,7.7,6.9,7.7 C6.2,7.7,5.6,8.2,5.6,9s0.6,1.3,1.3,1.3S8.2,9.7,8.2,9c0-0.2,0-0.4-0.1-0.6c0.2,0.1,0.4,0.1,0.6,0.1c0.7,0,1.3-0.6,1.3-1.3 S9.4,6,8.7,6z'}
					required={true} />

				<div className="form-row form-row-submit">
					<input id="forgotSubmit" className="form-submit" type="submit" value="Send" disabled={this.state.recoveryDisabled} />
				</div>
			</form>
		);
	}
}

export default Step1;


// WEBPACK FOOTER //
// ./src/recovery/Step1.js